import CameraImagesM from "@common/camera/CameraImagesM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import IconButtonM from "@common/components/button/IconButtonM"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { useCamera } from "@common/hooks/useCamera"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { formIds } from "@data/constants/formConstants"
import React, { useContext, useState } from "react"
import { View } from "react-native"
import { useSelector } from "react-redux"
import AudioVideoActivityStep from "../execute/AudioVideoActivityStep"

const MyWorkModal = ({
    activityId,
    images,
    setImages,
    isOpen,
    handleShowModal,
    onSubmit = () => {},
    activityType,
    status,
    setStatus,
    control,
    recordingURI,
    setRecordingURI,
    stepDescriptions,
    progress,
    submitted,
    onRetry,
}) => {
    const dimensions = useContext(DimensionsContext)

    const postActivityLogsRequest = useSelector(
        (state) => state.api.postActivityLogs?.request
    )
    const user = useSelector((state) => state.data?.currentUser?.object)

    const [launchCamera] = useCamera(formIds.NEW_MATERIAL, true, false)

    const [showInfo, setShowInfo] = useState(user?.xp <= 300)

    return (
        <ModalM
            visible={isOpen}
            onDismiss={() => {
                handleShowModal()
            }}
            style={{
                width: dimensions?.width > 800 ? "60%" : "90%",
                maxHeight: "80%",
                alignItems: "center",
            }}
        >
            <TextM
                fontSize={25}
                fontWeight={"ExtraBold"}
                color={theme.colors.primary}
                style={{
                    marginTop: 20,
                }}
            >
                {"Mon travail".toUpperCase()}
            </TextM>

            <IconButtonM
                onPress={() => {
                    setShowInfo(!showInfo)
                }}
                icon={"info"}
                size={12}
                style={{
                    height: 22,
                    width: 22,
                    backgroundColor: theme.colors.primary,
                    alignSelf: "center",
                    borderRadius: 20,
                    position: "absolute",
                    right: 20,
                    top: 20,
                }}
                iconColor={theme.colors.white}
            />

            {showInfo && (
                <TextM
                    style={{
                        marginBottom: 10,
                        textAlign: "center",
                        marginHorizontal: 10,
                    }}
                    fontSize={12}
                    wrap
                    color={theme.colors.grey}
                >
                    {stepDescriptions[1]}
                </TextM>
            )}
            {progress || submitted ? (
                <View
                    style={{
                        height: dimensions?.height * 0.4,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <TextM color={theme.colors.primary} fontWeight={"Bold"}>
                        Sauvegarde en cours … {progress}%{" "}
                    </TextM>
                </View>
            ) : activityType === "photo" ? (
                <CameraImagesM
                    images={images}
                    setImages={setImages}
                    activityId={activityId}
                    longPressDisabled={postActivityLogsRequest}
                    noButton
                    style={{
                        marginTop: 20,
                        width: "100%",
                    }}
                    formId={formIds.NEW_MATERIAL}
                    dismissModal={handleShowModal}
                    onRetry={onRetry}
                />
            ) : (
                <View
                    style={{
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <AudioVideoActivityStep
                        stepIndex={1}
                        status={status}
                        setStatus={setStatus}
                        finishStep={() => {}}
                        control={control}
                        stepData={[]}
                        recordingURI={recordingURI}
                        setRecordingURI={setRecordingURI}
                        style={{
                            width: "100%",
                        }}
                        hideModal={handleShowModal}
                    />
                </View>
            )}
            <View
                style={{
                    height: 30,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 4,
                }}
            ></View>
            {activityType === "photo" && (
                <FilledButtonM
                    color={theme.colors.primary}
                    trackingId={"my_work_modal.add_photo"}
                    mode={"outlined"}
                    style={{
                        width: "90%",
                        alignSelf: "center",
                    }}
                    onPress={() => {
                        launchCamera()
                        handleShowModal()
                    }}
                    icon={"camera"}
                    loading={postActivityLogsRequest || submitted}
                    disabled={postActivityLogsRequest || submitted}
                    label={"Ajouter une photo"}
                />
            )}
            <FilledButtonM
                color={theme.colors.success}
                trackingId={"my_work_modal.submit_activity"}
                disabled={
                    (activityType === "audio" && !recordingURI) ||
                    (images.length === 0 && activityType === "photo")
                }
                onPress={() => {
                    if (
                        (activityType === "audio" && !recordingURI) ||
                        (images.length === 0 && activityType === "photo")
                    )
                        return

                    onSubmit()
                    handleShowModal()
                    if (activityType === "audio") {
                        setStatus("finished")
                    }
                }}
                icon={"bolt"}
                style={{
                    width: "90%",
                    alignSelf: "center",
                }}
                label="Soumettre l'activité"
            />
            <FilledButtonM
                mode={"text"}
                trackingId={"my_work_modal.return"}
                color={theme.colors.primary}
                style={{
                    width: IS_WEB ? "50%" : "90%",
                    height: 40,
                    marginBottom: 10,
                }}
                contentStyle={{ height: 40 }}
                onPress={handleShowModal}
                label={"Retour"}
            />
        </ModalM>
    )
}

export default MyWorkModal
